var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("label", [
    _c("input", {
      staticClass: "peer absolute opacity-0 pointer-events-none",
      attrs: { type: _vm.inputType, name: _vm.name, required: _vm.required },
      domProps: { value: _vm.valueAttr, checked: _vm.value },
      on: {
        blur: function ($event) {
          return _vm.$emit("blur")
        },
        change: _vm.handleChange,
      },
    }),
    _vm._v(" "),
    _vm.multiple
      ? _c(
          "span",
          {
            staticClass:
              "block relative w-5 h-5 transition-colors text-white bg-white border border-blue mr-2.5 peer-checked:bg-blue",
          },
          [
            _c(
              "svg",
              { staticClass: "absolute top-1.5 left-[3px] w-3 h-2 stroke-2" },
              [_c("use", { attrs: { "xlink:href": "#icon-check" } })]
            ),
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _c("span", {
      staticClass: "font-[1rem] leading-[1.5] tracking-tight",
      domProps: { textContent: _vm._s(_vm.label) },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }